export default __webpack_public_path__ + "static/media/LAS0710.34I-35930_-20958_0.d4579b90.jpg";